import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import {
  Button,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  VStack,
} from '@chakra-ui/react'

import { Checkbox, Input, Select } from '@/components/Form'

import { useGCKCode } from '@/features/GCKCodes/useGCKCode'
import { useCostCenter } from '@/features/costCenters/useCostCenter'

const GCKCodeDetailModal = ({ modalDetail, setModalDetail }) => {
  const { show, isCreate, detail } = modalDetail

  // Data
  const [profitCenters, setProfitCenters] = useState([])

  // Hook
  const { useFetchAllCostCenters } = useCostCenter()
  const { useCreateGCKCode, useUpdateGCKCode } = useGCKCode()
  const { data: profitCenterResponse } = useFetchAllCostCenters({ page: 1, pageSize: 0, filters: { status: 'active' } })

  const createGCKCode = useCreateGCKCode()
  const updateGCKCode = useUpdateGCKCode()
  const methods = useForm({ defaultValues: detail })

  useEffect(() => {
    if (profitCenterResponse?.data) {
      setProfitCenters(
        profitCenterResponse.data.map((row) => ({
          value: row.profitCenterCode,
          label: `${row.profitCenterCode} - ${row.name}`,
        }))
      )
    }
  }, [profitCenterResponse?.data])

  useEffect(() => {
    methods.reset(detail)
  }, [detail, methods])

  const closeModal = () => {
    setModalDetail({
      show: false,
      isCreate: true,
      detail: {},
    })
  }
  const onSubmit = (data) => {
    if (isCreate) {
      createGCKCode.mutate(data, {
        onSuccess: () => {
          closeModal()
        },
      })
    } else {
      const id = detail._id

      if (!id) {
        return
      }

      updateGCKCode.mutate(
        { id, data },
        {
          onSuccess: () => {
            console.log('In update GCK')
            closeModal()
          },
        }
      )
    }
  }

  return (
    <Modal isOpen={show} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent maxW={'40%'}>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <ModalHeader>
              <Heading>{isCreate ? 'Add' : 'Update'} GCK Code</Heading>
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <VStack>
                <Select name="profitCenter" label="Profit Cetner" options={profitCenters} isRow />
                <Input name="description" label="Description" type="text" placeholder="Enter value" isRow />
                <Input name="GCK" label="GCK" type="text" placeholder="Enter value" isRow />
                <Input name="GCKDescription" label="GCKDescription" type="text" placeholder="Enter value" isRow />
                <Checkbox name="cRSPInUse" label="cRSP In Use" isRow />
              </VStack>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="green" mr={3} type="submit">
                {isCreate ? 'Add' : 'Update'}
              </Button>

              <Button colorScheme="gray" onClick={closeModal}>
                Close
              </Button>
            </ModalFooter>
          </form>
        </FormProvider>
      </ModalContent>
    </Modal>
  )
}

export default GCKCodeDetailModal
